import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from "../../contexts/UserContext";
import { PrimaryButton, PopUpWindow, OfferForm, OfferTable } from "../../components";
import { CircularProgress, Alert } from "@mui/material";
import apiUrl from "../../components/api";
import "./offerPage.css";
import PageStructure from "../page-structure/PageStructure";

const OfferPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showOfferForm, setShowOfferForm] = useState(false);
  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;

  const handleAddOfferClick = () => {
    setShowOfferForm(true);
  };

  return (
    <PageStructure>
      <div className="offer-page">
        <div className="offer-page-header">
          <h1>Offers</h1>
        {
            user.permissions.canCreateOffer &&
        <PrimaryButton
            text="Add New Offer"
            color="var(--primary-color)"
            onClick={handleAddOfferClick}
          />}
        </div>

        {showOfferForm && (
          <PopUpWindow
            title="Create New Offer"
            onClose={() => setShowOfferForm(false)}
          >
            <OfferForm
              onClose={() => setShowOfferForm(false)}
              onSuccess={() => {
                setShowOfferForm(false);
                // Refreshing is handled by the OfferTable component
              }}
            />
          </PopUpWindow>
        )}

        {loading ? (
          <div className="loading-container">
            <CircularProgress />
          </div>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <div className="offers-container">
            <OfferTable visibleSearch={true} />
          </div>
        )}
      </div>
    </PageStructure>
  );
};

export default OfferPage;
